<template>
  <v-form class='createMachineMaintenanceForm' v-model='valid' ref='createMachineMaintenanceForm'>
    <v-container class='mb-10'>
      <v-row>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <searchable-select :value.sync="machineMaintenance.machine_id" :options="{ url: 'machine', label: 'Machine'}" :errorMessage="error.machine_id" :selectedData="{'id': machineMaintenance.machine_id, 'text': machineMaintenance.machine_name}"/>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <v-text-field
            v-model="machineMaintenance.schedule_date"
            :error-messages="error.schedule_date"
            type="date"
            label="Schedule Date"
            autofocus
            ref="firstInput"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" sm="6" xs="12">
          <v-text-field
            v-model="machineMaintenance.completed_date"
            :error-messages="error.completed_date"
            type="date"
            label="Completed Date"
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
          <v-text-field
            v-model='machineMaintenance.cost'
            :error-messages='error.cost'
            label='Cost'
            placeholder='Cost'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12'>
         <v-checkbox
           v-model="machineMaintenance.is_break_down"
           label="Is Break Down"
         ></v-checkbox>
        </v-col>
        <v-col cols='12' md='3' sm='6' xs='12' class='radio-with-lable'>
          <label class="c-radio-label">Status</label>
          <v-radio-group v-model="machineMaintenance.status" row>
            <v-radio label="Active" :value="0" class="mt-0"></v-radio>
            <v-radio label="Inactive" :value="1" class="mt-0"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
    </v-container>
    <v-footer fixed>
      <v-col class="text-right">
        <v-btn color="primary" class="mr-2" @click="submit" small>{{ edit_id ? 'Update' : 'Add' }}</v-btn>
        <v-btn color="default" @click="reset" small>Reset</v-btn>
      </v-col>
    </v-footer>
  </v-form>
</template>

<script>
export default {
  watch: {
    $route: function () {
      this.edit_id = this.$route.params.id
      this.reset()
    }
  },
  mounted () {
    const id = this.$route.params.id
    if (id) {
      this.edit_id = id
      this.getDataById(id)
    } else {
      this.edit_id = undefined
      const storageData = localStorage.getItem('clone_data')
      if (storageData) {
        const _storageData = JSON.parse(storageData)
        this.getDataById(_storageData.module_id)
      }
      localStorage.removeItem('clone_data')
    }
  },
  data () {
    return {
      valid: false,
      edit_id: undefined,
      machineMaintenance: { status: 0 },
      error: {},
    }
  },
  methods: {
    getDataById (id) {
      this.$axios.post('getMachineMaintenanceById/' + id).then((res) => {
        this.machineMaintenance = res.data.data
      }).catch(() => {
        this.loading = false
        console.log('some error occurred')
      })
    },
    submit () {
      if (Object.keys(this.error).length > 0) {
        this.error = {}
        this.valid = true
      }
      if (this.valid) {
        const route = this.edit_id ? 'saveMachineMaintenance/' + this.edit_id : 'saveMachineMaintenance'
        this.$axios.post(route, this.machineMaintenance).then((res) => {
          this.$eventBus.$emit('$globalSnackbar', 'success', res.data.success_description)
          if (this.edit_id) {
            this.$router.push('/machineMaintenance')
          } else {
            this.reset()
          }
        }).catch((err) => {
          if (err.response.status === 422) {
            this.error = err.response.data.error_data
          } else {
            this.$eventBus.$emit('$globalSnackbar', 'red', err.response.data.error_description)
          }
        })
      } else {
        this.$refs.createMachineMaintenanceForm.validate()
      }
    },
    reset () {
      this.$refs.createMachineMaintenanceForm.reset()
      setTimeout(() => {
        this.machineMaintenance = { status: 0 }
        this.error = {}
        this.$refs.firstInput.focus()
      }, 300)
    },
  },
}
</script>

<style>
.createMachineMaintenanceForm .radio-with-lable .v-input--selection-controls {
  margin-top: 0px;
}
.createMachineMaintenanceForm .c-radio-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
</style>
